import { useEffect, useState } from "react";
import classes from "../Etablissements/Etablissements.module.css";
import { Card, Row, Table } from "antd";
import axiosInstance from "../../utils/axios";
import { useTranslation } from "react-i18next";

const Apprenants = () => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(true);
  const columns = [
    {
      title: t("Nom"),
      key: "Nom",
      render: (_, record) => (record?.name ? record?.name : t("Non renseigné")),
    },
    {
      title: t("Prénom"),
      key: "Prénom",
      render: (_, record) =>
        record?.surname ? record?.surname : t("Non renseigné"),
    },
    {
      title: t("Nationnalité"),
      key: "Nationnalité",
      render: (_, record) =>
        record?.nationality ? record?.nationality : t("Non renseigné"),
    },
    {
      title: t("Adresse e-mail"),
      key: "Adresse e-mail",
      render: (_, record) =>
        record?.adresse_mail ? record?.adresse_mail : t("Non renseigné"),
    },
    {
      title: t("Numéro de téléphone"),
      key: "Numéro de téléphone",
      render: (_, record) => (record?.tel ? record?.tel : t("Non renseigné")),
    },

    {
      title: t("Statut"),
      key: "statut",
      render: (_, record) => {
        return (
          <span
            style={{
              padding: "4px 10px",
              borderRadius: "5px",
              fontSize: "12px",
              backgroundColor: record?.statut_couleur_background,
              color: record?.couleur_statut,
            }}
          >
            {t(record?.statut_apprenant)}
          </span>
        );
      },
    },

    {
      title: t("Action"),
      key: "Action",
    },
  ];
  const [data, setData] = useState([]);
  useEffect(() => {
    async function fetchData() {
      axiosInstance
        .get(`${import.meta.env.VITE_APP_GEOPROD_API}/list_apprenant`, {
          headers: {
            Idsession: JSON.parse(localStorage.getItem("-x-token-user"))
              ?.Acces_Token,
          },
        })
        .then((res) => {
          setData(res?.data?.message?.Data);
          setLoading(false);
        })
        .catch(() => {
          setLoading(false);
        });
    }

    fetchData();
  }, []);

  return (
    <div>
      <Row className={classes.listeRow}>
        <Card
          className={classes.listeCard}
          bordered={false}
          title={
            <h2  style={{ color: '#2A96FF' }}>{t("Liste des apprenants")}</h2>
          }
        >
          <Table
            loading={loading}
            locale={{ emptyText: t("Aucune donnée") }}
            columns={columns}
            dataSource={data}
            className="ant-border-space"
            style={{ overflowX: "auto" }}
            pagination={false}
          />
        </Card>
      </Row>
    </div>
  );
};

export default Apprenants;
